module.exports = __webpack_public_path__ + "img/GoDown.8372b69.svg";